export const appBaseURL = "/"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1,user-scalable=no, viewport-fit=cover"},{"charset":"utf-8"},{"name":"description","content":"Block chain game"}],"link":[{"rel":"preconnect","data-href":"https://cdn.jsdelivr.net/npm/gsap@3.12.5/+esm","as":"script"},{"rel":"preconnect","data-href":"https://cdn.skypack.dev/gsap@3.12.5","as":"script"},{"rel":"preconnect","data-href":"https://cdn.jsdelivr.net/npm/echarts@5.6.0/dist/echarts.min.js","as":"script"},{"rel":"preconnect","data-href":"https://cdn.bootcdn.net/ajax/libs/echarts/5.6.0/echarts.min.js","as":"script"},{"rel":"preconnect","data-href":"https://cdn.bootcdn.net/ajax/libs/cropperjs/2.0.0/cropper.esm.min.js","as":"script"},{"rel":"preconnect","data-href":"https://cdn.jsdelivr.net/npm/cropperjs@2.0.0/+esm","as":"script"},{"rel":"stylesheet","data-href":"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"}],"style":[],"script":[{"src":"/polyfill-global-this.js","defer":true},{"innerHTML":"\n(function fnSetScheduler() {\n  // @ts-ignore\n  window.scheduler = window.scheduler || {};\n  window.scheduler.yield = window.scheduler.yield || (() => new Promise((resolve) => {\n    setTimeout(resolve, 0);\n  }));\n})();\n\n\n(function fnToLoadCDN() {\n  const fn = (event) => {\n    console.log('readyState =', document.readyState, new Date().toISOString());\n    const iStatus = { interactive: 0, complete: 1 }[document.readyState];\n    const todo =\n    iStatus === 0 /* ←暂定0, 按需要切换 */ ||\n    event.type == \"DOMContentLoaded\";\n\n    if (!todo) return;\n    document.querySelectorAll(\n      'html > head > link[data-href]'\n    ).forEach((cur) => {\n      const href = cur.getAttribute('data-href');\n      cur.setAttribute('href', href);\n    });\n  };\n  const aEvent = ['readystatechange', 'DOMContentLoaded'];\n  /* [0]稍早，[1]稍迟，按需选择加载时机（初步看选择0更好一点） */\n  document.addEventListener(aEvent[0], fn);\n})();\n\n\n"}],"noscript":[],"title":"BetCorgi","charset":"utf-8","viewport":"width=device-width, initial-scale=1,user-scalable=no, viewport-fit=cover"}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = false

export const remoteComponentIslands = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'